import { createContext } from 'react';

/**
 * Context that tells the Mermaid `errorComponent` whether the surrounding
 * markdown block is still streaming.
 *
 * During streaming, partially-emitted Mermaid code blocks are unavoidably
 * malformed for several frames before they parse cleanly. The default
 * Streamdown error UI flashes a loud red "Mermaid Error: ..." panel for those
 * frames (issue EVI-1158, video). While streaming we render nothing for parse
 * errors and let the diagram pop in once the block is fully received.
 *
 * Declared apart from the error component so that file exports only components
 * and Fast Refresh does not fall back to a full reload.
 */
export const MermaidStreamingContext = createContext(false);
